import type { RiskFilters } from "@/infrastructure/repositories/risks.supabase.repository";

export const risksKeys = {
  all: ["risks"] as const,
  list: (filters: RiskFilters = {}) => [...risksKeys.all, "list", filters] as const,
  detail: (id: string) => [...risksKeys.all, "detail", id] as const,
};
